export const allOption = {
  value: '*',
  label: 'Select all',
};

export default {};
